import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { IntDatePipe } from './int-date.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ IntDatePipe ],
    exports: [ IntDatePipe ],
    providers: [ DatePipe ],
})
export class IntDatePipeModule {}
